exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".indicator[data-v-5175cad8] {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 22px;\n}\n.indicator .spacer[data-v-5175cad8] {\n  width: 40px;\n  border-radius: 9999px;\n  background-color: #085FCE;\n  height: 2px;\n}", ""]);

// exports
